import { Grid } from '@/atoms';
import { Pagination } from '@/molecules';

import { usePagination } from '@/hooks';
import { toArray } from '@/utils';

import type { FunctionComponent } from 'react';
import type { TypeCardsPaginationProps } from './types';

export const CardsPagination: FunctionComponent<TypeCardsPaginationProps> = ({
  className = '',
  children,
}: TypeCardsPaginationProps) => {
  const { currentItems, currentPage, handlePageChange } = usePagination(
    toArray(children)
  );

  return (
    <div className={`flex flex-col gap-6 md:gap-20 ${className}`}>
      <Grid xs={1} md={2} lg={3} outline={false} className="gap-5 md:gap-8">
        {currentItems.map((item, index) => (
          <Grid.Item key={index}>{item}</Grid.Item>
        ))}
      </Grid>

      {currentItems.length !== toArray(children).length && (
        <Pagination
          onPageChange={handlePageChange}
          pageCount={currentPage}
          className="mx-auto"
        />
      )}
    </div>
  );
};

CardsPagination.displayName = 'CardsPagination';
